import { render, staticRenderFns } from "./cate-index.vue?vue&type=template&id=26bf9b7e&scoped=true"
import script from "./cate-index.vue?vue&type=script&lang=js"
export * from "./cate-index.vue?vue&type=script&lang=js"
import style0 from "./cate-index.vue?vue&type=style&index=0&id=26bf9b7e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "26bf9b7e",
  null
  
)

export default component.exports